import { defineStore } from 'pinia';
import { ref } from 'vue';

export const TOAST_VARIANT = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export type ToastVariant = (typeof TOAST_VARIANT)[keyof typeof TOAST_VARIANT];

export interface AppToast {
  message: string;
  variant: ToastVariant;
}

const useGlobalStore = defineStore('global', () => {
  const loadedTheme = ref('portal');
  const routeLoading = ref(false);
  const toast = ref<AppToast | null>(null);
  /** Permite que uma view suprima o rodapé global enquanto exibe seu próprio loading interno (ex.: sincronização pós-login). */
  const footerHidden = ref(false);

  function showToast(message: string, variant: ToastVariant = TOAST_VARIANT.ERROR): void {
    toast.value = { message, variant };
  }

  function clearToast(): void {
    toast.value = null;
  }

  const reset = () => {
    routeLoading.value = false;
    footerHidden.value = false;
    clearToast();
  };

  return {
    loadedTheme,
    routeLoading,
    toast,
    footerHidden,

    showToast,
    clearToast,
    reset,
  };
});

export default useGlobalStore;
